import Table from './Table';

const SmallTable = (props) => <Table {...props} className="small-table" />;

export default SmallTable;
